import { render, staticRenderFns } from "./Mensa.vue?vue&type=template&id=5b429fe7&scoped=true&"
import script from "./Mensa.vue?vue&type=script&lang=js&"
export * from "./Mensa.vue?vue&type=script&lang=js&"
import style0 from "./Mensa.vue?vue&type=style&index=0&id=5b429fe7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b429fe7",
  null
  
)

export default component.exports